import React, { FC } from 'react';
import styled from 'styled-components';
import { PageWrapperStyles } from '../../../common/styles';

const FooterWrapper = styled.div`
  ${PageWrapperStyles}

  border-top: 0.0625rem solid rgb(58, 58, 58);
  flex: 0 0 auto;
  min-height: 5rem;
`;

const QuickViewOverlayFooter: FC = () => {
  return <FooterWrapper />;
};

export default QuickViewOverlayFooter;
